// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalInfo_header__WeAv1","footer":"ModalInfo_footer__3LHv7"};